/* eslint-disable import/no-cycle */
import { IAppointment } from './appointments';
import { IUser } from './user';

export enum MessageStatus {
  UNREAD = 'UNREAD',
  READ = 'READ',
  REVOKED = 'REVOKED',
}

export type IChatRelation = Partial<{
  leftTime: string;
  user: IUser;
}>;

export type IMessage = Partial<{
  id: string;
  from: Partial<IUser>;
  chatRoom: IChatRoom;
  message: string;
  status: MessageStatus;
  unreadMessagesCount: number;
  createdAt: string;
}>;

export type IChatRoom = Partial<{
  id: string;
  createdAt: string;
  lastMessage: IMessage;
  unreadMessagesCount: number;
  appointment: IAppointment;
  chatRelations: IChatRelation[];
}>;
